import './App.css';
import Cloud from './components/Cloud';
import Logo from './components/Logo';
import Upload from './components/Upload';
import PaperPlanes from './components/PaperPlanes';
import Footer from './components/Footer';
import Edit from './components/Edit';
import {Routes, Route } from "react-router-dom";
import { BrowserRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import About from './components/About';

function App() {
  
  const step = useSelector(state => state.step)

  return (
    <div className="App">
      <Cloud/>
      <PaperPlanes/>
      <div className='centerArea'>
        <Logo/>
        <BrowserRouter basename='/10DaysOfCode-LTE'>
          <Routes>
            <Route path='' element={step === "upload" ? <Upload/> : <Edit/>} />
            <Route path="/about" element={<About/>}/>
          </Routes>
        </BrowserRouter>
        
        
        
      </div>
      <div style={{ flexGrow: 1 }}></div>
      <Footer/>
    </div>
  );
}

export default App;
